/**
 * Lightweight analytics helper.
 *
 * Events are pushed to the GTM dataLayer (see GTMLoader) and, when a gtag
 * instance is present, forwarded to GA4 as well. Safe to call anywhere — it
 * no-ops when no tag is installed.
 */

declare global {
  interface Window {
    dataLayer?: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

export type AnalyticsParams = Record<string, unknown>;

export const trackEvent = (event: string, params: AnalyticsParams = {}) => {
  if (typeof window === "undefined") return;
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
    if (typeof window.gtag === "function") {
      window.gtag("event", event, params);
    }
  } catch {
    // Analytics must never break the shopping flow.
  }
};

/* --- Checkout hand-off tracking ------------------------------------------ */

const PENDING_KEY = "rsg_pending_checkout";

export interface PendingCheckout {
  cartId?: string;
  startedAt: number;
  value: number;
  itemCount: number;
}

export const setPendingCheckout = (pending: PendingCheckout) => {
  try {
    window.sessionStorage.setItem(PENDING_KEY, JSON.stringify(pending));
  } catch {
    /* storage unavailable */
  }
};

export const readPendingCheckout = (): PendingCheckout | null => {
  try {
    const raw = window.sessionStorage.getItem(PENDING_KEY);
    return raw ? (JSON.parse(raw) as PendingCheckout) : null;
  } catch {
    return null;
  }
};

export const clearPendingCheckout = () => {
  try {
    window.sessionStorage.removeItem(PENDING_KEY);
  } catch {
    /* storage unavailable */
  }
};
